import { Pagination, Table } from "@alifd/next";
import { DropdownButton } from "../dropdown-button";
import { ACTIVE_USER_ACTIONS, CONVERT_FIELDS, DELETED_USER_ACTIONS, PAGE_SIZE } from "./constants";

interface UserListTableProps {
    dataSource: any[];
    selectedRowKeys: any[];
    columnWidth: Record<string, number>;
    total: number;
    currentPage: number;
    divHeight: any;
    actionItems: typeof ACTIVE_USER_ACTIONS;
    onAction: (actionId: string, value: any, record: any) => void;
    onSelectionChange: (selectedKeys: any[], records: any[]) => void;
    onColumnResize: (dataIndex: string, value: number) => void;
    onPaginationChange: (current: number) => void;
}

export function UserListTable({
    dataSource: tableDataSource,
    selectedRowKeys,
    columnWidth,
    total,
    currentPage,
    divHeight,
    actionItems,
    onAction,
    onSelectionChange,
    onColumnResize,
    onPaginationChange,
}: UserListTableProps) {
    const actionCellRender = (value: any, index: number, record: any) => {
        return (
            <DropdownButton
                className="ellipsis-btn"
                style={{ borderRadius: '5px', padding: 0, width: '33px', height: '33px', color: '#262A2A', backgroundColor: '#F6F6F6', border: '1px solid #E8E8E8' }}
                type="normal"
                size="medium"
                popupTriggerType="click"
                icon="ellipsis"
                content=""
                itemClick={(args: any) => onAction(args.id, value, record)}
                items={actionItems}
            />
        );
    };

    return (
        <div className="flex-1 margin-top-16 custom-table display-flex-col" style={{ overflow: 'auto' }}>
            <Table.StickyLock
                className="bef-user-content flex-1"
                fixedHeader
                size='medium'
                maxBodyHeight={divHeight}
                primaryKey="UserId"
                dataSource={tableDataSource}
                hasBorder={false}
                rowSelection={{
                    selectedRowKeys,
                    onChange: onSelectionChange,
                }}
                onResizeChange={onColumnResize}
            >
                <Table.Column asyncResizable title="操作" lock='right' dataIndex="UserId" cell={actionCellRender} width={105} />
                <Table.Column asyncResizable title="用户编号" dataIndex="UserId" width={columnWidth.UserId} />
                <Table.Column asyncResizable title="用户名" dataIndex="UserName" width={columnWidth.UserName} />
                <Table.Column asyncResizable title="状态" dataIndex="State" width={columnWidth.State} cell={(value: any) => CONVERT_FIELDS.State[value] ?? value} />
                <Table.Column asyncResizable title="邮箱" dataIndex="Email" width={columnWidth.Email} />
                <Table.Column asyncResizable title="手机号码" dataIndex="PhoneNumber" width={columnWidth.PhoneNumber} />
                <Table.Column asyncResizable title="地址" dataIndex="Address" width={columnWidth.Address} />
            </Table.StickyLock>

            <div className="display-flex justify-end margin-top-8 margin-bottom-8 margin-right-6">
                <Pagination
                    shape="no-border"
                    pageSize={PAGE_SIZE}
                    total={total}
                    current={currentPage}
                    onChange={onPaginationChange}
                />
            </div>
        </div>
    );
}
